// Tickets left for one event session. Backend's per-ticket ticketsAvailable does not follow later edits to the
// session limit, so cap it by the limit. Sold-out sessions have no ticketDetails entry.
export const ticketsRemaining = (event, scheduleId) => {
  const session = (event?.sessions || []).find((s) => s.scheduleId === scheduleId)
  const ticket = (event?.ticketDetails || []).find((t) => t.scheduleId === scheduleId)
  if (!session || !ticket) return 0

  return Math.max(0, Math.min(Number(ticket.ticketsAvailable) || 0, Number(session.limit) || 0))
}
